import React from 'react';

import type { FC } from 'react';

export const House: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...props}>
      <path d="M12.4973 24.1586V17.9086H17.4973V24.1586C17.4973 24.8461 18.0598 25.4086 18.7473 25.4086H22.4973C23.1848 25.4086 23.7473 24.8461 23.7473 24.1586V15.4086H25.8723C26.4473 15.4086 26.7223 14.6961 26.2848 14.3211L15.8348 4.90859C15.3598 4.48359 14.6348 4.48359 14.1598 4.90859L3.70981 14.3211C3.28481 14.6961 3.54731 15.4086 4.12231 15.4086H6.24731V24.1586C6.24731 24.8461 6.80981 25.4086 7.49731 25.4086H11.2473C11.9348 25.4086 12.4973 24.8461 12.4973 24.1586Z" />
    </svg>
  );
};
